import React from 'react'
import styled from 'styled-components'
import { number, string, bool } from 'prop-types'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { navigate } from '@reach/router'
import { useGlobal } from '../../../contexts/GlobalContext'
import {
  AVISO_COBRANCA_BOLETO_PENDENTE_MENSAGEM,
  AVISO_COBRANCA_BOLETO_PENDENTE_TITULO,
  AVISO_COBRANCA_PIX_PENDENTE_MENSAGEM,
  EVENTOS_GA,
  INFORMACAO_MODALIDADES,
  ROUTE_BASEPATH,
  URLS,
} from '../../../constants'
import { enviaEventoGA } from '../../../utils/helpers/helpersGA'
import Mensagem from '../../../components/Mensagem/Mensagem'
import { URLS_APP } from '../../../config'
import { ReactComponent as LogoCuradoriaIcon } from '../../../assets/icons/Logo_curadoria.svg'
import { ReactComponent as LogoIneditosIcon } from '../../../assets/icons/logo_ineditos.svg'
import PendingPix from '../../../components/PendingPix/PendingPix'

const Container = styled.div``

const Titulo = styled.h2`
  margin: 0;
  padding-left: 18px;
  display: flex;
  align-items: center;
`

const Texto = styled.p`
  ${( { fontWeight } ) => fontWeight === 'bold' ? StyleGuide.boldFonte : StyleGuide.defaultFonte};
  line-height: 1.6;
  margin: ${( { margin } ) => margin || `1em 0`};

  padding: 0 30px 0 30px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding: 0 20px 0 20px;
  }
`

const ImagemKit = styled.img`
  display: block;
  height: auto;
  margin: 0 auto;
  max-width: 85%;

  padding: 0 30px 0 30px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding: 0 20px 0 20px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  button {
    width: 100%;
    padding: 15px 10px;
  }
  padding: 0 30px 0 30px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding: 0 20px 0 20px;
  }
`

const Header = styled.div`
  padding: 0 30px 0 30px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding: 0 20px 0 20px;
  }
  display: flex;
`

const PendingPixWrapper = styled.div`
  padding: 0 0 30px 0;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    padding: 0 0 20px 0;
  }
`

const CardAssineClube = ( { idParaAssinar, slugModalidadeAssinada, temCobrancaBoletoPendente, temCobrancaPixPendente } ) => {
  const { detalhesModalidades } = useGlobal()
  const findDetalheModalidadePorId = detalhesModalidades && detalhesModalidades.find( detalhe => detalhe.id === idParaAssinar )
  const informacaoModalidadePorId = INFORMACAO_MODALIDADES.find( info => info.id === idParaAssinar )

  if ( !detalhesModalidades && !findDetalheModalidadePorId && !informacaoModalidadePorId && !idParaAssinar ) {
    return null
  }

  return (
    <Container>
      <Card
        className="card"
        largura="100%"
        margin=""
        padding="0"
      >
        <Header>

          {informacaoModalidadePorId.slug === 'ineditos' ?
            <LogoIneditosIcon />
            :
            <LogoCuradoriaIcon />}

          <Titulo>
            { `Assine também a ${informacaoModalidadePorId.titulo}!` }
          </Titulo>
        </Header>

        { findDetalheModalidadePorId ?
          <Texto margin="1em 0 1.5em">
            { findDetalheModalidadePorId.resumo }
          </Texto> : null }

        <ImagemKit
          src={ informacaoModalidadePorId.fotos.kit }
        />

        { !temCobrancaBoletoPendente && !temCobrancaPixPendente &&
        <ButtonContainer>
          <Button
            onClick={ () => {
              enviaEventoGA( EVENTOS_GA.SEGUNDA_ASSINATURA.FLUXO, EVENTOS_GA.SEGUNDA_ASSINATURA.ACOES.INIT )
              navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${slugModalidadeAssinada}/${URLS.PLANO}/${URLS.SEGUNDA_ASSINATURA_PLANO}` )
            } }
            tema={ informacaoModalidadePorId.slug === 'ineditos' ? Button.BOTAO_INEDITOS :Button.BOTAO_CURADORIA }
            testId="botao-home-segunda-assinatura"
          >
            {
              informacaoModalidadePorId.slug === 'ineditos' ?
                'Quero assinar a Inéditos' :
                'Quero assinar a Curadoria'
            }
          </Button>
        </ButtonContainer> }

        { temCobrancaBoletoPendente ?
          <Mensagem
            isAlerta={ true }
            texto={ AVISO_COBRANCA_BOLETO_PENDENTE_MENSAGEM }
            titulo={ AVISO_COBRANCA_BOLETO_PENDENTE_TITULO }
          /> : null }

        <PendingPixWrapper>
          <PendingPix
            message={ AVISO_COBRANCA_PIX_PENDENTE_MENSAGEM }
            pixData={ temCobrancaPixPendente }
          />
        </PendingPixWrapper>
      </Card>
    </Container>
  )
}

CardAssineClube.propTypes = {
  'idParaAssinar': number.isRequired,
  'slugModalidadeAssinada': string.isRequired,
  'temCobrancaBoletoPendente': bool.isRequired,
  'temCobrancaPixPendente': bool.isRequired,
}

export default CardAssineClube
